export default __webpack_public_path__ + "static/media/bkg--masterplan.c921e9ed.jpg";